<template>
    <div>
        <div class="filter">
            <div class="container">
                <div class="icon"><i></i> <span></span> <a data-toggle="collapse" href="#filters">Filter</a></div>

                <div class="collapse" id="filters" v-bind:class="{ show: showFiltersOnLoad }">
                    <div class="row filterdropdown">

                        <div class="col-md">
                            <select class="form-control" id="filterselect" @change="filter()" v-model="currentFilters.state">
                                <option value="">State</option>
                                <option v-for="state in filters.states">{{ state }}</option>
                            </select>
                        </div>
                        <div class="col-md">
                            <select class="form-control" id="filterselect" @change="filter()" v-model="currentFilters.usage">
                                <option value="">Usage</option>
                                <option v-for="usage in filters.usages">{{ usage }}</option>
                            </select>
                        </div>
                        <div class="col-md">
                            <select class="form-control" id="filterselect" @change="filter()" v-model="currentFilters.type">
                                <option value="">Property Type</option>
                                <option v-for="type in filters.propertyTypes">{{ type }}</option>
                            </select>
                        </div>
                        <div class="col-md">
                            <select class="form-control" id="filterselect" @change="filter()" v-model="currentFilters.size">
                                <option value="">Sq. Ft.</option>
                                <option value="0-1500">0-1,500</option>
                                <option value="1500-2500">1,500-2,500</option>
                                <option value="2500-5000">2,500-5,000</option>
                                <option value="5000-10000">5,000-10,000</option>
                                <option value="10000-999999">10,000+</option>

                            </select>
                        </div>

                        <div class="col-md">
                            <button class="btn" @click="reset()">Reset</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-2"></div>
                <div class="col text-center propertytype">
                    <button disabled="disabled">
                        <div class="row justify-center-content">
                            <div class="col-1"></div>
                            <div class="col list" :class="{active: active == 'list'}"><a @click="active='list'">List</a></div>
                            <div class="col grid" :class="{active: active == 'grid'}"><a @click="active='grid'">Grid</a></div>
                            <div class="col map" :class="{active: active == 'map'}"><a @click="active='map'">Map</a></div>
                            <div class="col-1"></div>
                        </div>
                    </button>
                </div>
                <div class="col-2"></div>
            </div>

            <property-map v-show="active=='map'" :properties="filteredProperties"></property-map>
            <property-grid v-if="active=='grid'" :properties="filteredProperties"></property-grid>
            <property-list v-if="active=='list'" :properties="filteredProperties"></property-list>

            <p v-if="!filteredProperties.length">No properties match your current criteria.</p>

        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import PropertyMap from './PropertyMap.vue'
    import PropertyGrid from './PropertyGrid.vue'
    import PropertyList from './PropertyList.vue'

    export default {
        props: ['stateFilter'],
        components: {
            PropertyMap,
            PropertyGrid,
            PropertyList
        },
        data() {
            return {
                active: 'map',
                properties: [],
                filteredProperties: [],
                filters: [],
                currentFilters: this.defaultFilters(),
                showFiltersOnLoad: false,
            }
        },
        mounted() {
            axios.get('/api/v1/properties').then(response => {
                this.properties = this.filteredProperties = response.data.properties;
                this.filters = response.data.filters;

                this.setStateFilter();

                if (localStorage.getItem('currentFilters')) {
                    this.currentFilters = JSON.parse(localStorage.getItem('currentFilters'));
                    this.showFiltersOnLoad = this.hasActiveFilter();
                    this.filter();
                }
            });
        },
        methods: {
            filter() {
                localStorage.setItem('currentFilters', JSON.stringify(this.currentFilters));

                this.filteredProperties = this.properties.filter(property => {
                    let filter = this.currentFilters;
                    for (let key in filter) {
                        // if the filter isn't set, skip it
                        if (filter[key] === '') {
                            continue;
                        }

                        // sizes are done on a min/max scale instead of a straight up comparison 
                        // data is stored as min-max
                        if (key === 'size') {
                            const sizes = filter[key].split('-', 2);
                            if (parseInt(property.square_feet) < parseInt(sizes[0]) || parseInt(property.square_feet) >= parseInt(sizes[1])) {
                                return false;
                            }
                        }
                        else if (filter[key] !== property[key]) {
                            return false;
                        }
                    }
                    return true;
                });
            },
            defaultFilters() {
                return {
                    state: '',
                    type: '',
                    usage: '',
                    size: '',
                }
            },
            hasActiveFilter() {
                return !(JSON.stringify(this.currentFilters) === JSON.stringify(this.defaultFilters()));
            },
            reset() {
                this.currentFilters = this.defaultFilters();
                localStorage.setItem('currentFilters', JSON.stringify(this.currentFilters));
                this.filteredProperties = this.properties;
            },
            setStateFilter() {
                if (this.stateFilter) {
                    this.currentFilters = this.defaultFilters();
                    this.currentFilters.state = this.stateFilter;
                    localStorage.setItem('currentFilters', JSON.stringify(this.currentFilters));
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// themes/ldc/assets/js/properties/Properties.vue